import { API } from "./shared";

export const SCHOOL_COLOR = "#007a9e";
export const PORTFOLIO_COLOR = "#6b3fa0";

const FINAL = new Set(["completed", "approved", "locked", "submitted", "submitted_for_review", "final"]);

// Chip state from an existing diagnostic/request status: not_started | in_progress | final
export const flowState = (status) => {
  const s = String(status || "").toLowerCase();
  if (FINAL.has(s)) return "final";
  if (s && s !== "not_started" && s !== "pending" && s !== "requested" && s !== "invited") return "in_progress";
  return "not_started";
};

export const FLOW_LABEL = { not_started: "Not started", in_progress: "In progress", final: "Final" };

// Compare availability (Dirk: available once BOTH have started; Provisional until both final).
export const compareState = ({ school, portfolio, included }) => {
  if (!included) return { enabled: false, tag: null, reason: "Not included in this period" };
  if (school === "not_started" && portfolio === "not_started")
    return { enabled: false, tag: null, reason: "Waiting for the school and you to start" };
  if (school === "not_started") return { enabled: false, tag: null, reason: "Waiting for the school to start" };
  if (portfolio === "not_started") return { enabled: false, tag: null, reason: "Waiting for you to start your assessment" };
  if (school === "final" && portfolio === "final") return { enabled: true, tag: "Ready", reason: null };
  return { enabled: true, tag: "Provisional", reason: null };
};

// Latest period (by created_at) that includes the school, with its request row.
// Shared "current period" rule (Dirk): latest-created NON-DRAFT period that includes the school.
export const periodsForSchool = (periods, tenantId) =>
  (periods || [])
    .filter((p) => p.status !== "draft")
    .map((p) => ({ period: p, req: (p.requests || []).find((q) => q.tenant_id === tenantId) }))
    .filter((x) => x.req)
    .sort((a, b) => String(b.period.created_at || "").localeCompare(String(a.period.created_at || "")));

export const openPortfolioAssessment = async (pid, periodId, tenantId) => {
  const r = await fetch(`${API}/api/portfolio/${pid}/periods/${periodId}/schools/${tenantId}/portfolio-assessment`, { method: "POST", credentials: "include" });
  const d = await r.json();
  if (!r.ok) throw new Error(d.detail || "Could not open the portfolio assessment");
  localStorage.setItem("diag_session", JSON.stringify({
    user: d.user, tenant: d.tenant, session_token: d.session_token,
    acting_as: "portfolio", access: d.access, portfolio_context: d.portfolio_context,
    loginAt: new Date().toISOString(),
  }));
  window.location.assign(`/diagnostic/form?diag=${d.diagnostic_id}`);
};

export const assessmentActionLabel = (state) =>
  state === "final" ? "Your assessment" : state === "in_progress" ? "Continue your assessment" : "Start your assessment";

export const currentPeriodLabel = (periods, tenantId) => {
  const e = periodsForSchool(periods, tenantId)[0];
  return e ? `${e.period.name} · ${FLOW_LABEL[flowState(e.req.status)]}` : null;
};
